import { IJwtToken } from '../context/model';
const MGPGroup = ['MGP', 'TIMPAE', 'MANDAE'];

export const isMgpAdmin = (jwtData: IJwtToken | null): boolean => {
    if(jwtData && (jwtData.roles === 'MGP_ADMINISTRATOR' || jwtData.roles === '86f82974-43fa-4add-9fd3-276a6cef9a11')) {
        return true;
    }

    return false;
}
export const isMGPAffiliation = (role?: string) => {
    if(!role) return false;
    return MGPGroup.findIndex(e=> e === role) !== -1
}